import * as React from "react";

import { Org } from "src/domain/administrative/config-management/api/getOrg";

export const MyOrgContext = React.createContext<Org>(null);
